import { api } from "@/lib/api";

export const UPGRADE_EVENT = "snaplist:upgrade";

export const openUpgrade = (detail = {}) =>
  window.dispatchEvent(new CustomEvent(UPGRADE_EVENT, { detail }));

export const PLANS = {
  starter: { lookupKey: "snaplist_starter_monthly", price: "$13", per: "/month", label: "Get Starter — $13/mo" },
  monthly: { lookupKey: "snaplist_pro_monthly", price: "$29.99", per: "/month", label: "Go Pro — $29.99/mo" },
  yearly: { lookupKey: "snaplist_pro_yearly", price: "$329.99", per: "/year", label: "Go Pro — $329.99/yr", badge: "1 month free" },
  research: { lookupKey: "snaplist_research_monthly", price: "$19.99", per: "/month", label: "Get Research — $19.99/mo" },
  team: { lookupKey: "snaplist_team_monthly", price: "$69.99", per: "/month", label: "Get Team — $69.99/mo" },
  team_yearly: { lookupKey: "snaplist_team_yearly", price: "$769.99", per: "/year", label: "Get Team Yearly — $769.99/yr", badge: "1 month free" },
};

export async function startCheckout(lookupKey = PLANS.monthly.lookupKey) {
  const { data } = await api.post("/payments/checkout", { lookup_key: lookupKey, origin_url: window.location.origin });
  // Existing subscribers are switched in place (prorated) — no checkout page.
  window.location.href = data.changed ? "/billing?changed=1" : data.checkout_url;
}

export async function openPortal() {
  const { data } = await api.post("/payments/portal", { origin_url: window.location.origin });
  window.location.href = data.url;
}

// Pull a human message out of FastAPI detail (string or {message}).
export const errorMessage = (e, fallback) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  return d?.message || e?.message || fallback;
};
